import "./index.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import { BsFillArrowLeftSquareFill } from "react-icons/bs";
import { FaPlus, FaTrash, FaExternalLinkAlt } from "react-icons/fa";

import { useUpdateNodeInternals } from "reactflow";

import nameConditions from "../../../helpers/nameConditions";

import AddVariablesInText from "../AddVariablesInText";
import { CreateTask } from "./CreateTask";
import { validateTaskData } from "../../../helpers/validate-task-data";
import { CreateDeal } from "./CreateDeal";
import { validateDealData } from "../../../helpers/validate-deal-data";
import { CreateTicket } from "./CreateTicket";
import { validateTicketData } from "../../../helpers/validate-ticket-data";
import { handleHeaderByType } from "../../../helpers/header-action";
import { toast } from "react-toastify";
import { AccountContext } from "../../../context/Account";
import { handlePropertyVar } from "../../../helpers/handle-var-property";
import { FileUploader } from "../FileUploader";
import { HelpMessage } from "../HelpMessage";

const webhookMethods = [
	{
		value: "post",
		label: "POST",
	},
	{
		value: "get",
		label: "GET",
	},
	{
		value: "put",
		label: "PUT",
	},
	{
		value: "patch",
		label: "PATCH",
	},
	{
		value: "delete",
		label: "DELETE",
	},
];

function Modal(props) {
	const { account } = useContext(AccountContext);

	const updateNodeInternals = useUpdateNodeInternals();
	//webhook
	const [webhookMethod, setwebhookMethod] = useState("POST");
	const [webhookHeaders, setWebhookHeaders] = useState([]);

	//question
	// const [question, setquestion] = useState("");
	const [questionVar, setquestionVar] = useState("");
	const [questionErrorMessage, setQuestionErrorMessage] = useState("");
	const [questionTypeResponse, setQuestionTypeResponse] = useState("simple");
	const [questionResponseActions, setQuestionResponseActions] = useState({});
	const [duplicateError, setDuplicateError] = useState("");

	// msg text
	const [msgType, setMsgType] = useState("text");
	const [msgMedia, setMediaURL] = useState({});
	const [file, setFile] = useState(null);

	//conditional
	const [condVar, setcondVar] = useState("");
	const [condVarRef, setcondVarRef] = useState("");
	const [condType, setcondType] = useState("");
	const [condValueVisible, setcondValueVisible] = useState(true);
	const [condTypeVisible, setcondTypeVisible] = useState(true);

	// comment
	const [comment, setComment] = useState("");

	//gush
	const [gushSector, setgushSector] = useState({});
	const [gushType, setGushType] = useState("default");
	const [onlyOwnerGush, setOnlyOwnerGush] = useState(false);
	const [gushOperators, setgushOperators] = useState([]);
	const [gushChoose, setgushChoose] = useState("sector");

	// tags to set
	const [tagsToSet, setTagsToSet] = useState([]);

	// ai agent selection
	const [aiAgent, setAiAgent] = useState("");
	const [aiInputVariables, setAiInputVariables] = useState([]);
	const [aiOutputMapping, setAiOutputMapping] = useState([]);

	//jump
	const [jumpVar, setjumpVar] = useState("");
	const [jumps, setjumps] = useState({});

	//outputbalancer
	const [balancerOutputs, setBalancerOutputs] = useState({});

	//setvar
	const [varToSet, setvarToSet] = useState("");
	const [valueToset, setvalueToset] = useState("");

	const [messageWarning, setmessageWarning] = useState("");
	const [inputsSaveResp, setinputsSaveResp] = useState([]);
	const [webhookVars, setwebhookVars] = useState({});
	const [webhookResps, setwebhookResps] = useState({});
	const [objectData, setObjectData] = useState({});
	const [wppFlows, setWppFlows] = useState({});
	//sleep
	const [sleepSeconds, setSleepSeconds] = useState(0);

	const msgMessage = useRef(null);
	const webhookUrl = useRef(null);
	const webhookBody = useRef(null);
	const question = useRef(null);
	const condValue = useRef(null);
	const messageMidiaUrl = useRef(null);
	const aiInputVarRefs = useRef({});
	const gushInternalIdRef = useRef(null);

	useEffect(() => {
		if (["ik", "cpf", "cnpj", "number", "date"].includes(condType)) {
			setcondValueVisible(false);
			condValue.current.textContent = "";
		} else {
			setcondValueVisible(true);
		}
	}, [condType]);

	useEffect(() => {
		if (
			[
				"contact_exists",
				"contact_deal",
				"contact_deal_exists",
				"contact_deal_won",
				"contact_deal_lost",
			].includes(condVar)
		) {
			setcondValueVisible(false);
			setcondTypeVisible(false);
			condValue.current.textContent = "";
			return;
		}
		setcondValueVisible(true);
		setcondTypeVisible(true);
	}, [condVar]);

	const checkVarExists = (v) => {
		v = v.replace("{{", "");
		v = v.replace("}}", "");
		if (props.variables.find((i) => i.name == v)) {
			return true;
		}
		return false;
	};

	const handleContentToPut = (content) => {
		content = content.replaceAll("\r\n", "<br>");
		content = content.replaceAll("\n", "<br>");

		let regexVars = new RegExp(`{{([^}]*)}}`, "gm");
		let result;
		let c2 = content;
		while ((result = regexVars.exec(c2))) {
			const varToReplace = result[0];
			if (checkVarExists(varToReplace)) {
				content = content.replaceAll(
					varToReplace,
					`<span contenteditable="false" class="variableInText">${varToReplace}</span>`
				);
			}
		}

		return content;
	};

	useEffect(() => {
		if (!props.active) {
			setObjectData({});
			setComment("");
			setquestionVar("");
			setQuestionErrorMessage("");
			setQuestionTypeResponse("simple");
			setQuestionResponseActions({});
			setDuplicateError("");
			setcondVar("");
			setcondType("");
			setcondValueVisible(true);
			setjumpVar("");
			setjumps({});
			setBalancerOutputs({});
			setvarToSet("");
			setvalueToset("");
			setinputsSaveResp([]);
			setwebhookVars({});
			setwebhookResps({});
			setSleepSeconds(0);
			setWebhookHeaders([]);
			setTagsToSet([]);
			setMsgType("text");
			setMediaURL({});
			setFile(null);
			setAiAgent("");
			setAiInputVariables([]);
			setOnlyOwnerGush(false);
			setGushType("default");
			setWppFlows({});
		}
	}, [props.active]);

	useEffect(() => {
		if (msgMessage.current) {
			let x = handleContentToPut(
				props.nodeToEdit?.msgMessage ? props.nodeToEdit.msgMessage : ""
			);

			if (x && x.includes("delay")) {
				x = x.replace("<delay>", "&lt;delay&gt;");
				x = x.replace("</delay>", "&lt;/delay&gt;");
			}

			msgMessage.current.innerHTML = x;
		}

		setMsgType(props.nodeToEdit.msgType ?? "text");
		setMediaURL(props.nodeToEdit.msgMedia ?? {});

		if (webhookUrl.current) {
			webhookUrl.current.innerHTML = handleContentToPut(
				props.nodeToEdit?.webhookUrl ? props.nodeToEdit.webhookUrl : ""
			);
		}

		setwebhookMethod(props.nodeToEdit?.webhookMethod ?? "POST");

		if (webhookBody.current) {
			webhookBody.current.innerHTML = handleContentToPut(
				props.nodeToEdit?.webhookBody ? props.nodeToEdit.webhookBody : ""
			);
		}

		if (question.current) {
			let x = handleContentToPut(
				props.nodeToEdit?.question ? props.nodeToEdit.question : ""
			);

			if (x && x.includes("delay")) {
				x = x.replace("<delay>", "&lt;delay&gt;");
				x = x.replace("</delay>", "&lt;/delay&gt;");
			}

			question.current.innerHTML = x;
		}

		if (condValue.current) {
			condValue.current.innerHTML = handleContentToPut(
				props.nodeToEdit?.condValue ? props.nodeToEdit.condValue : ""
			);
		}
		setObjectData(props.nodeToEdit.objectData || {});

		const varsSave = props.nodeToEdit?.webhookSaveVars;
		const webhookHeadersSave = props.nodeToEdit?.webhookHeaders || [];
		const inputs = [];
		let xResps = {};
		let xVars = {};
		if (varsSave) {
			for (let i = 0; i < varsSave.length; i++) {
				inputs.push(i);
				xResps = {
					...xResps,
					[i]: varsSave[i].varJson,
				};
				xVars = {
					...xVars,
					[i]: varsSave[i].varBot,
				};
			}
		}

		setinputsSaveResp(inputs);
		setwebhookResps(xResps);
		setwebhookVars(xVars);
		if (webhookHeadersSave.length) {
			setWebhookHeaders(
				webhookHeadersSave.map((webhook) => {
					return {
						...webhook,
						id: webhook._id,
					};
				})
			);
		}

		const jumpsNode = props.nodeToEdit?.jumps;
		let xJumps = {};
		if (jumpsNode) {
			for (let i = 0; i < jumpsNode.length; i++) {
				if (jumpsNode[i] == "default") {
					continue;
				}
				xJumps = {
					...xJumps,
					[i]: jumpsNode[i],
				};
			}
		}
		setjumps(xJumps);
		setjumpVar(props.nodeToEdit?.jumpVar ? props.nodeToEdit.jumpVar : "email");

		const balancerNode = props.nodeToEdit?.balancerOutputs;
		let xBalancer = {};
		if (balancerNode) {
			for (let i = 0; i < balancerNode.length; i++) {
				xBalancer[i] = {
					name: balancerNode[i].name,
					percentage: balancerNode[i].percentage,
				};
			}
		}
		setBalancerOutputs(xBalancer);

		setMsgType(props.nodeToEdit?.msgType ?? "text");
		if (messageMidiaUrl.current) {
			messageMidiaUrl.current.innerHTML = handleContentToPut(
				props.nodeToEdit?.msgMedia?.urlText ?? ""
			);
		}
		setvarToSet(
			props.nodeToEdit?.varToSet ? props.nodeToEdit.varToSet : "email"
		);
		setComment(props.nodeToEdit?.comment);
		setvalueToset(
			props.nodeToEdit?.valueToset ? props.nodeToEdit.valueToset : ""
		);

		setTagsToSet(props.nodeToEdit?.chatTags || []);

		setquestionVar(
			props.nodeToEdit?.questionVar ? props.nodeToEdit.questionVar : ""
		);
		setQuestionErrorMessage(props.nodeToEdit?.questionErrorMessage || "");

		setSleepSeconds(
			props.nodeToEdit?.sleepSeconds ? props.nodeToEdit.sleepSeconds : 0
		);

		setQuestionTypeResponse(
			props.nodeToEdit?.questionTypeResponse
				? props.nodeToEdit.questionTypeResponse
				: "simple"
		);

		setWppFlows(props.nodeToEdit?.wppFlows || {});

		setgushChoose(props.nodeToEdit?.gushChoose || "sector");
		setgushOperators(props.nodeToEdit?.gushOperators || []);

		if (
			props.nodeToEdit?.questionButtons &&
			props.nodeToEdit?.questionTypeResponse == "buttons"
		) {
			const auxBtn = {};
			props.nodeToEdit.questionButtons.forEach((x) => {
				if (x.id == 0) {
					return;
				}
				auxBtn[x.id] = x.textButton;
			});

			setQuestionResponseActions(auxBtn);
		}

		if (
			props.nodeToEdit?.questionList &&
			props.nodeToEdit?.questionList?.sections &&
			props.nodeToEdit?.questionTypeResponse == "list"
		) {
			const auxList = { sections: {} };

			let sectionId = 1;
			props.nodeToEdit.questionList.sections.forEach((sec) => {
				if (sec.sectionTitle == "default") {
					return;
				}
				const items = {};
				sec.items.forEach((it) => {
					const id = it.id.split("-")[3];
					items[id] = {
						id: it.id,
						title: it.title,
						description: it.description,
					};
				});

				auxList.sections[sectionId] = {
					title: sec.sectionTitle,
					items,
				};
				sectionId++;
			});

			if (props.nodeToEdit.questionList?.buttonTitle) {
				auxList.buttonTitle = props.nodeToEdit.questionList?.buttonTitle;
			}

			setQuestionResponseActions(auxList);
		}
		let tempSectorGush = "";
		if (props.sectors && props.sectors[0]) {
			tempSectorGush = props.sectors[0];
		}

		setgushSector(
			props.nodeToEdit?.gushSector
				? props.nodeToEdit.gushSector
				: tempSectorGush
		);

		if (props.nodeToEdit?.gushSettings) {
			setOnlyOwnerGush(props.nodeToEdit?.gushSettings?.onlyOwnerGush ?? false);
			setGushType(props.nodeToEdit?.gushSettings?.gushType ?? "default");
		}

		let tempCondVar = "";
		if (props?.variables[0]?.name) {
			tempCondVar = props.variables[0].name;
		}
		setcondVar(
			props.nodeToEdit?.condVar ? props.nodeToEdit?.condVar : tempCondVar
		);
		setcondType(props.nodeToEdit?.condType ? props.nodeToEdit.condType : "eq");

		// preload ai agent if exists
		if (props.nodeToEdit?.aiAgentId) {
			setAiAgent(props.nodeToEdit.aiAgentId);
		}

		// preload ai input variables if exists
		if (
			props.nodeToEdit?.aiInputVariables &&
			Array.isArray(props.nodeToEdit.aiInputVariables)
		) {
			const varsWithIds = props.nodeToEdit.aiInputVariables.map((v, idx) => ({
				...v,
				id: v.id || Date.now() + idx,
			}));
			setAiInputVariables(varsWithIds);
		} else {
			setAiInputVariables([]);
		}

		// preload ai output mapping if exists
		if (
			props.nodeToEdit?.aiInputOutputMapping &&
			Array.isArray(props.nodeToEdit.aiInputOutputMapping)
		) {
			const mappingsWithIds = props.nodeToEdit.aiInputOutputMapping.map(
				(m, idx) => ({
					...m,
					id: m.id || Date.now() + idx,
				})
			);
			setAiOutputMapping(mappingsWithIds);
		} else {
			setAiOutputMapping([]);
		}
	}, [props.nodeToEdit, msgMessage.current, messageMidiaUrl.current]);

	useEffect(() => {
		if (gushChoose !== "internal_id" || !gushInternalIdRef.current) {
			return;
		}

		gushInternalIdRef.current.innerHTML = handleContentToPut(
			props.nodeToEdit?.gushInternalId ?? ""
		);
	}, [gushChoose, props.nodeToEdit]);

	useEffect(() => {
		// Atualizar conteúdo dos campos de variáveis de entrada apenas no carregamento inicial
		aiInputVariables.forEach((inputVar) => {
			const labelEl = aiInputVarRefs.current[`${inputVar.id}-label`];
			const valueEl = aiInputVarRefs.current[`${inputVar.id}-value`];

			// Só atualiza se o campo estiver vazio (primeira renderização)
			if (labelEl && !labelEl.textContent) {
				labelEl.innerHTML = handleContentToPut(inputVar.label || "");
			}
			if (valueEl && !valueEl.textContent) {
				valueEl.innerHTML = handleContentToPut(inputVar.value || "");
			}
		});
	}, [aiInputVariables]);

	const addInputJump = () => {
		const idx = String(new Date().getTime());
		setjumps({ ...jumps, [idx]: "" });
	};

	const removeJump = (remove) => {
		const x = { ...jumps };
		delete x[remove];
		setjumps(x);
	};

	const addBalancerOutput = () => {
		const idx = String(new Date().getTime());
		setBalancerOutputs({
			...balancerOutputs,
			[idx]: { name: "", percentage: 0 },
		});
	};

	const removeBalancerOutput = (remove) => {
		const x = { ...balancerOutputs };
		delete x[remove];
		setBalancerOutputs(x);
	};

	const onchangeBalancerName = (key, value) => {
		setBalancerOutputs({
			...balancerOutputs,
			[key]: { ...balancerOutputs[key], name: value },
		});
	};

	const onchangeBalancerPercentage = (key, value) => {
		const num = Math.max(0, Math.min(100, parseInt(value) || 0));
		setBalancerOutputs({
			...balancerOutputs,
			[key]: { ...balancerOutputs[key], percentage: num },
		});
	};

	const addInputResp = () => {
		const x = inputsSaveResp[inputsSaveResp.length - 1];
		const y = x ? x : 0;
		setinputsSaveResp(inputsSaveResp.concat(y + 1));
	};

	const addAiInputVariable = () => {
		setAiInputVariables([
			...aiInputVariables,
			{ id: Date.now(), label: "", value: "" },
		]);
	};

	// Abre a listagem de agentes de IA em NOVA guia (não fecha o fluxo atual).
	// Origem depende do ambiente (localhost = dev; senão produção) e da origem do
	// frame: isRvopsFrame = CRM (mesma heurística do "Fechar fluxo"), senão Spread.
	// No CRM o client id vem por query param no src do iframe (ver rvops-crm:
	// ElozConfigBundle/Assets/js/chatbots.js).
	const handleOpenAiAgents = () => {
		const params = new URLSearchParams(window.location.search);
		const isRvopsFrame = params.get("isRvopsFrame") === "true";
		const isLocalhost = ["localhost", "127.0.0.1"].includes(
			window.location.hostname
		);
		const clientId = params.get("clientId");

		let url;
		if (isRvopsFrame) {
			url = isLocalhost
				? `http://localhost:8181/${clientId}/s/settings/ia/agents`
				: `https://app.rvops.com/${clientId}/s/settings/ia/agents`;
		} else {
			url = isLocalhost
				? "http://localhost:3001/ai-agents"
				: "https://app.spread.chat/ai-agents";
		}

		window.open(url, "_blank", "noopener");
	};

	const removeAiInputVariable = (id) => {
		setAiInputVariables(aiInputVariables.filter((v) => v.id !== id));
	};

	const updateAiInputVariable = (id, field, htmlValue) => {
		// Processar o HTML para salvar o conteúdo formatado
		const textValue = handleContentToSave(htmlValue);
		setAiInputVariables(
			aiInputVariables.map((v) =>
				v.id === id ? { ...v, [field]: textValue } : v
			)
		);
	};

	// Funções para mapeamento de saída (agente -> bot)
	const addAiOutputMapping = () => {
		setAiOutputMapping([
			...aiOutputMapping,
			{ id: Date.now(), botVariable: "", agentVariable: "" },
		]);
	};

	const removeAiOutputMapping = (id) => {
		setAiOutputMapping(aiOutputMapping.filter((m) => m.id !== id));
	};

	const updateAiOutputMapping = (id, field, value) => {
		setAiOutputMapping(
			aiOutputMapping.map((m) => (m.id === id ? { ...m, [field]: value } : m))
		);
	};

	const countItemsList = () => {
		let c = 0;
		Object.keys(questionResponseActions.sections).forEach((sec) => {
			c = c + Object.keys(questionResponseActions.sections[sec].items).length;
		});
		return c;
	};

	const addItemSectionQuestion = (x) => {
		if (countItemsList() == 10) {
			return alert("O limite de itens é 10");
		}

		let newItemId = 1;
		if (questionResponseActions.sections[x].items) {
			newItemId =
				parseInt(
					Object.keys(questionResponseActions.sections[x].items)[
						Object.keys(questionResponseActions.sections[x].items).length - 1
					]
				) + 1;
		}

		if (isNaN(newItemId)) {
			newItemId = 1;
		}

		questionResponseActions.sections[x].items[newItemId] = {
			id: `sec-${x}-item-${newItemId}`,
			title: "",
			description: "",
		};

		setQuestionResponseActions({ ...questionResponseActions });
	};

	const addSectionListQuestion = () => {
		let newSectorId = 1;
		if (questionResponseActions && questionResponseActions.sections) {
			newSectorId =
				parseInt(
					Object.keys(questionResponseActions.sections)[
						Object.keys(questionResponseActions.sections).length - 1
					]
				) + 1;
		} else {
			questionResponseActions["sections"] = {};
		}

		questionResponseActions.sections[newSectorId] = {
			title: "",
			items: {
				1: {
					id: `sec-${newSectorId}-item-1`,
					title: "",
					description: "",
				},
			},
		};

		setQuestionResponseActions({ ...questionResponseActions });
	};

	const addInputButton = () => {
		let itemsAction = Object.keys(questionResponseActions);

		let newId = 1;
		if (itemsAction.length) {
			newId = parseInt(itemsAction[itemsAction.length - 1]) + 1;
		}

		if (Object.keys(questionResponseActions).length > 2) {
			return alert("Você só pode adicionar 3 botões");
		}

		setQuestionResponseActions({
			...questionResponseActions,
			[newId]: "",
		});
	};

	const validateAllButtons = (actions) => {
		const values = Object.entries(actions)
			.filter(([_, val]) => val && val.trim())
			.map(([id, val]) => ({ id, value: val.trim().toLowerCase() }));

		for (let i = 0; i < values.length; i++) {
			for (let j = i + 1; j < values.length; j++) {
				if (values[i].value === values[j].value) {
					return `Botão "${values[j].value}" está duplicado.`;
				}
			}
		}
		return "";
	};

	const validateAllListItems = (sections) => {
		if (!sections) return "";

		const sectionTitles = [];
		for (const sectionKey of Object.keys(sections)) {
			const section = sections[sectionKey];

			const sectionTitle = section.title?.trim().toLowerCase();
			if (sectionTitle) {
				if (sectionTitles.includes(sectionTitle)) {
					return `Sessão "${section.title}" está duplicada.`;
				}
				sectionTitles.push(sectionTitle);
			}

			if (!section.items) continue;

			const itemTitlesInSection = [];
			for (const itemKey of Object.keys(section.items)) {
				const title = section.items[itemKey]?.title?.trim().toLowerCase();
				if (title) {
					if (itemTitlesInSection.includes(title)) {
						return `Item "${section.items[itemKey]?.title}" está duplicado na sessão "${section.title || "sem nome"}".`;
					}
					itemTitlesInSection.push(title);
				}
			}
		}
		return "";
	};

	const removeInputButton = (x) => {
		let newActions = { ...questionResponseActions };
		delete newActions[x];

		setQuestionResponseActions(newActions);

		const error = validateAllButtons(newActions);
		setDuplicateError(error);
	};

	const removeSession = (x) => {
		const newSections = { ...questionResponseActions.sections };
		delete newSections[x];
		const newActions = { ...questionResponseActions, sections: newSections };
		setQuestionResponseActions(newActions);

		const error = validateAllListItems(newSections);
		setDuplicateError(error);
	};

	const removeSessionItem = (x, it) => {
		const newSections = { ...questionResponseActions.sections };
		const newItems = { ...newSections[x].items };
		delete newItems[it];
		newSections[x] = { ...newSections[x], items: newItems };

		const newActions = { ...questionResponseActions, sections: newSections };
		setQuestionResponseActions(newActions);

		const error = validateAllListItems(newSections);
		setDuplicateError(error);
	};

	const removeInputResp = (i) => {
		const x = inputsSaveResp.filter((ipvar) => ipvar !== i);
		setinputsSaveResp(x);

		delete webhookVars[i];
		setwebhookVars(webhookVars);

		delete webhookResps[i];
		setwebhookResps(webhookResps);
	};

	const handleContentToSave = (html) => {
		html = html.replaceAll("<div><br></div>", "\r\n");
		html = html.replaceAll("<br>", "\r\n");
		html = html.replaceAll("<div>", "\r\n");
		html = html.replaceAll("&nbsp;", " ");
		html = html.replaceAll(/(<([^>]+)>)/gi, ""); // Hello World
		html = html.replaceAll("&amp;", "&");
		return html;
	};

	const saveNode = () => {
		if (props.nodeToEdit.type === "message") {
			const msgMessageAux = handleContentToSave(msgMessage.current.innerHTML)
				.replaceAll("\n", "")
				.replaceAll("\r", "")
				.replaceAll("\t", "")
				.trim();

			if (!msgMessageAux.length && msgType === "text") {
				toast.warn("Preencha corretamente o campo de mensagem.");
				return;
			}

			if (msgType === "media" && !file && !props.nodeToEdit.msgMedia) {
				toast.warn("Preencha corretamente o campo de URL.");
				return;
			}

			let msgMediaAux = msgMedia;

			if (msgType === "text") {
				setMediaURL({});
				setFile(null);
				msgMediaAux = {};
			}

			if (msgType === "media") {
				const msgMediaAuxData = {
					url: props.nodeToEdit.msgMedia?.url ?? "",
					type: file?.type ?? props.nodeToEdit.msgMedia?.type,
					name: file?.name ?? props.nodeToEdit.msgMedia?.name,
					file,
				};
				setMediaURL(msgMediaAuxData);
				msgMediaAux = msgMediaAuxData;
			}

			if (msgType === "media-url") {
				setFile(null);
				msgMediaAux = {
					urlText:
						handleContentToSave(messageMidiaUrl.current.innerHTML)
							?.replaceAll("\n", "")
							?.replaceAll("\r", "")
							?.replaceAll("\t", "")
							?.trim() ??
						props.nodeToEdit?.msgMedia?.urlText ??
						"",
					url: "",
					type: "",
					name: "",
					file: null,
				};
				setMediaURL(msgMediaAux);
			}

			props.saveNode({
				ref: props.nodeToEdit.ref,
				msgMessage: handleContentToSave(msgMessage.current.innerHTML),
				msgType,
				msgMedia: msgMediaAux,
			});
		}

		if (props.nodeToEdit.type === "gush") {
			let gushObject = {
				ref: props.nodeToEdit.ref,
				gushSector,
				gushChoose,
				gushOperators,
				gushSettings: {
					gushType,
					onlyOwnerGush,
				},
				gushInternalId:
					handleContentToSave(gushInternalIdRef?.current?.innerHTML ?? "") ??
					"",
			};

			if (gushChoose === "operator") {
				gushObject.gushSector = null;
				gushObject.gushInternalId = null;
			}

			if (gushChoose === "sector") {
				gushObject.gushOperators = [];
				gushObject.gushInternalId = null;
			}

			if (gushChoose === "internal_id") {
				gushObject.gushOperators = [];
			}

			console.log(gushObject);

			props.saveNode(gushObject);
		}

		if (props.nodeToEdit.type === "sleep") {
			props.saveNode({ ref: props.nodeToEdit.ref, sleepSeconds });
		}

		if (props.nodeToEdit.type === "settag") {
			props.saveNode({ ref: props.nodeToEdit.ref, chatTags: tagsToSet });
		}

		if (props.nodeToEdit.type === "setvar") {
			props.saveNode({ ref: props.nodeToEdit.ref, varToSet, valueToset });
		}

		if (props.nodeToEdit.type === "createnote") {
			props.saveNode({ ref: props.nodeToEdit.ref, comment });
		}

		if (props.nodeToEdit.type === "aiagent") {
			// Validação das variáveis de entrada
			if (aiInputVariables.length > 0) {
				const hasEmptyFields = aiInputVariables.some(
					(v) => !v.label.trim() || !v.value.trim()
				);
				if (hasEmptyFields) {
					toast.warn(
						"Preencha todos os campos de Label e Valor ou remova as variáveis vazias."
					);
					return;
				}
			}

			// Validação do mapeamento de saída
			if (aiOutputMapping.length > 0) {
				const hasEmptyMappings = aiOutputMapping.some(
					(m) => !m.botVariable || !m.agentVariable
				);
				if (hasEmptyMappings) {
					toast.warn(
						"Preencha todos os campos do mapeamento de saída ou remova os vazios."
					);
					return;
				}
			}

			const options = props.agents?.length
				? props.agents
				: props.operators || [];
			const found = options.find((a) => a?.id == aiAgent || a?._id == aiAgent);

			// Preparar variáveis de entrada sem o ID (usado apenas na UI)
			const inputVarsToSave = aiInputVariables.map(({ label, value }) => ({
				label: label.trim(),
				value: value.trim(),
			}));

			// Preparar mapeamento de saída sem o ID (usado apenas na UI)
			const outputMappingToSave = aiOutputMapping.map(
				({ botVariable, agentVariable }) => ({
					botVariable,
					agentVariable,
				})
			);

			// Obter os outputs do agente selecionado
			const aiOutputs = found?.outputs || [];

			// Atualizar os internals do nó para forçar a atualização dos handles
			updateNodeInternals(props.nodeToEdit.ref);

			// Remover conexões de outputs que não existem mais
			const outputsEdited =
				props.nodeToEdit?.aiOutputs?.filter(
					(oldOutput) =>
						!aiOutputs.some((newOutput) => newOutput.name === oldOutput.name)
				) || [];

			props.setEdges((eds) => {
				const ids = [];
				outputsEdited.forEach((removedOutput) => {
					const found = eds.find(
						(edge) =>
							edge.source === props.nodeToEdit.ref &&
							edge.sourceHandle === removedOutput.name
					);

					if (found) {
						ids.push(found.id);
					}
				});

				const newEdges = eds.filter((edge) => !ids.includes(edge.id));

				return newEdges;
			});

			props.saveNode({
				ref: props.nodeToEdit.ref,
				aiAgentId: aiAgent,
				aiAgentName: found?.name || "",
				aiInputVariables: inputVarsToSave,
				aiOutputs: aiOutputs,
				aiInputOutputMapping: outputMappingToSave,
			});
		}

		if (props.nodeToEdit.type === "webhook") {
			const webhookSaveVars = [];

			if (
				!webhookVars ||
				!webhookResps ||
				webhookVars.length != webhookResps.length
			) {
				return alert("Preencha todos os campos");
			}

			if (webhookHeaders.some((header) => !header.label)) {
				toast.warn("Preencha corretamente os Headers do Webhook.");
				return;
			}

			webhookHeaders.forEach((header) => {
				const headerValue = document.querySelector(
					`[data-header-id="${header.id}"]`
				);
				header.value = headerValue.textContent;
			});

			Object.keys(webhookVars).forEach((i) => {
				webhookSaveVars.push({
					varJson: webhookResps[i],
					varBot: webhookVars[i],
				});
			});

			props.saveNode({
				ref: props.nodeToEdit.ref,
				webhookUrl: handleContentToSave(webhookUrl.current.innerHTML),
				webhookBody: handleContentToSave(webhookBody.current.innerHTML),
				webhookMethod,
				webhookSaveVars,
				webhookHeaders,
			});
		}

		if (props.nodeToEdit.type === "jump") {
			updateNodeInternals(props.nodeToEdit.ref);
			let jumpsSave = [];

			Object.keys(jumps).forEach((x) => {
				jumpsSave.push(jumps[x]);
			});

			if (jumpsSave.includes("default")) {
				jumpsSave = jumpsSave.filter((x) => x != "default");
			}
			jumpsSave.push("default");

			const jumpsEdited =
				props.nodeToEdit?.jumps?.filter((j) => !jumpsSave.includes(j)) || [];

			props.setEdges((eds) => {
				const ids = [];
				jumpsEdited.forEach((b) => {
					const found = eds.find(
						(a) => a.source === props.nodeToEdit.ref && a.sourceHandle == b
					);

					if (found) {
						ids.push(found.id);
					}
				});

				const newEdges = eds.filter((edge) => !ids.includes(edge.id));

				return newEdges;
			});

			props.saveNode({
				ref: props.nodeToEdit.ref,
				jumpVar,
				jumps: jumpsSave,
			});
		}

		if (props.nodeToEdit.type === "outputbalancer") {
			updateNodeInternals(props.nodeToEdit.ref);

			const outputsSave = Object.values(balancerOutputs).filter(
				(o) => o.name && o.percentage > 0
			);

			const totalPercent = outputsSave.reduce(
				(sum, o) => sum + o.percentage,
				0
			);
			if (totalPercent !== 100) {
				toast.warn(
					`A soma das probabilidades deve ser 100%. Atual: ${totalPercent}%`
				);
				return;
			}

			const validOutputNames = outputsSave.map((o) => o.name);
			const previousNames =
				props.nodeToEdit?.balancerOutputs?.map((o) => o.name) || [];
			const removedNames = previousNames.filter(
				(n) => !validOutputNames.includes(n)
			);

			props.setEdges((eds) => {
				const idsToRemove = [];
				removedNames.forEach((name) => {
					const found = eds.find(
						(a) => a.source === props.nodeToEdit.ref && a.sourceHandle === name
					);
					if (found) idsToRemove.push(found.id);
				});
				return eds.filter((edge) => !idsToRemove.includes(edge.id));
			});

			props.saveNode({
				ref: props.nodeToEdit.ref,
				balancerOutputs: outputsSave,
			});
		}

		if (props.nodeToEdit.type === "question") {
			let questionButtons = [];
			let questionList = {};

			if (questionTypeResponse === "buttons") {
				questionButtons = Object.keys(questionResponseActions).map((x) => {
					return {
						id: x,
						textButton: questionResponseActions[x],
					};
				});
				questionButtons = questionButtons.filter((x) => x.id != 0);
				questionButtons.push({ id: 0, textButton: "default" });
			}
			if (questionTypeResponse === "list" && questionResponseActions.sections) {
				questionList["buttonTitle"] =
					questionResponseActions?.buttonTitle || "Selecionar opção";
				questionList["sections"] = Object.keys(
					questionResponseActions.sections
				).map((x) => {
					return {
						sectionTitle: questionResponseActions.sections[x].title,
						items: Object.keys(questionResponseActions.sections[x].items).map(
							(it) => {
								return {
									id: questionResponseActions.sections[x].items[it].id,
									title: questionResponseActions.sections[x].items[it].title,
									description:
										questionResponseActions.sections[x].items[it].description,
								};
							}
						),
					};
				});

				questionList["sections"] = questionList["sections"].filter(
					(x) => x.sectionTitle != "default"
				);
				questionList["sections"].push({
					sectionTitle: "default",
					items: [
						{
							id: "list-0",
							title: "",
							description: "",
						},
					],
				});
			}

			const questionText = handleContentToSave(
				question.current.innerHTML
			).replaceAll("&amp;", "&");

			props.saveNode({
				ref: props.nodeToEdit.ref,
				question: questionText,
				questionVar,
				questionErrorMessage,
				questionTypeResponse,
				questionButtons,
				questionResponseActions,
				questionList,
			});
		}

		if (props.nodeToEdit.type === "conditional") {
			const isCustomCondition = props.contactConditions.find(
				(condition) => condition.value === condVar
			);
			let conditionVar = condVar;

			let value = handleContentToSave(condValue.current.innerHTML);

			if (isCustomCondition) {
				value = isCustomCondition.condValue;
			}

			props.saveNode({
				ref: props.nodeToEdit.ref,
				condVar: conditionVar,
				condType,
				condValue: value,
			});
		}

		if (props.nodeToEdit.type === "createtask") {
			const isTaskValid = validateTaskData();
			if (isTaskValid === false) return;
			props.saveNode({
				ref: props.nodeToEdit.ref,
				objectData: isTaskValid,
			});
		}

		if (props.nodeToEdit.type === "createdeal") {
			const isDealValid = validateDealData();
			if (isDealValid === false) return;
			props.saveNode({
				ref: props.nodeToEdit.ref,
				objectData: isDealValid,
			});
		}

		if (props.nodeToEdit.type === "createticket") {
			const isTicketValid = validateTicketData();
			if (isTicketValid === false) return;
			console.log(isTicketValid);
			props.saveNode({
				ref: props.nodeToEdit.ref,
				objectData: isTicketValid,
			});
		}

		if (props.nodeToEdit.type === "wppFlows") {
			props.saveNode({
				ref: props.nodeToEdit.ref,
				wppFlows,
			});
		}
	};

	const formatJson = () => {
		try {
			const x = JSON.parse(webhookBody.current.textContent);
			const y = JSON.stringify(x, undefined, 4);
			webhookBody.current.innerHTML = handleContentToPut(y);

			setmessageWarning("");
		} catch (e) {
			if (webhookBody != "") {
				setmessageWarning("json inválido");
			} else {
				setmessageWarning("");
			}
		}
	};

	const addWebhookHeader = () => {
		setWebhookHeaders((headers) => {
			return [
				...headers,
				{
					value: "",
					label: "",
					id: Date.now(),
				},
			];
		});
	};

	const handleRemoveHeader = (header) => {
		setWebhookHeaders((headers) => {
			const remainHeaders = headers.filter((h) => h.id !== header.id);
			return remainHeaders;
		});
	};

	const onchangeVarsResps = (x) => {
		const id = x.id.split("-")[1];
		if (x.id.includes("var")) {
			setwebhookVars({ ...webhookVars, [id]: x.value });
		} else {
			setwebhookResps({ ...webhookResps, [id]: x.value });
		}
	};

	const onchangeJump = (x) => {
		const id = x.id.split("-")[1];
		setjumps({ ...jumps, [id]: x.value });
	};

	const onchangeRespButtons = (x) => {
		const id = x.id.split("-")[2];
		if (x.value && x.value.length > 20) {
			x.value = x.value.substring(0, 20);
		}
		setQuestionResponseActions({ ...questionResponseActions, [id]: x.value });
	};

	const onBlurRespButtons = (x) => {
		const id = x.id.split("-")[2];
		const newActions = { ...questionResponseActions, [id]: x.value };

		const error = validateAllButtons(newActions);
		setDuplicateError(error);
	};

	const onchangeSectionTitle = (x) => {
		const id = x.id.split("-")[1];
		if (x.value && x.value.length > 20) {
			x.value = x.value.substring(0, 20);
		}

		questionResponseActions.sections[id].title = x.value;
		setQuestionResponseActions({ ...questionResponseActions });
	};

	const onBlurSectionTitle = () => {
		const error = validateAllListItems(questionResponseActions.sections);
		setDuplicateError(error);
	};

	const onchangeButtonTitle = (x) => {
		const sectionId = x.id.split("-")[1];
		const itemId = x.id.split("-")[3];

		if (x.value && x.value.length > 24) {
			x.value = x.value.substring(0, 24);
		}

		questionResponseActions.sections[sectionId].items[itemId].title = x.value;
		setQuestionResponseActions({ ...questionResponseActions });
	};

	const onBlurButtonTitle = (x) => {
		const error = validateAllListItems(questionResponseActions.sections);
		setDuplicateError(error);
	};

	const onchangeButtonDescription = (x) => {
		const sectionId = x.id.split("-")[1];
		const itemId = x.id.split("-")[3];

		if (x.value && x.value.length > 72) {
			x.value = x.value.substring(0, 72);
		}

		questionResponseActions.sections[sectionId].items[itemId].description =
			x.value;
		setQuestionResponseActions({ ...questionResponseActions });
	};

	const onchangeButtonSectionTitle = (x) => {
		questionResponseActions.buttonTitle = x.value;
		setQuestionResponseActions({ ...questionResponseActions });
	};

	const handlePaste = (e) => {
		e.preventDefault();
		document.execCommand(
			"inserttext",
			false,
			e.clipboardData.getData("text/plain")
		);
	};

	function handleWebhookHeaders(currentHeader, action) {
		return (e) => {
			setWebhookHeaders((headers) => {
				return headers.map((header) => {
					const headerFound = header.id === currentHeader.id;
					if (headerFound) {
						header[action] = e.target.value;
					}

					return header;
				});
			});
		};
	}

	function handleCustomOptions() {
		if (!account?.elozAccount) {
			return (
				<>
					<option value="contact_exists">Contato - é conhecido</option>
				</>
			);
		}

		return props.contactConditions.map((option) => (
			<option
				value={option.value}
				data-ref={option.ref}
				data-ref-parent={option.parent}
			>
				{option.label}
			</option>
		));
	}

	return (
		<>
			<div className={`modalBlackout ${props.active ? "" : "modalHide"}`}></div>
			<div className={`modalDiv ${props.active ? "" : "modalHide"}`}>
				<div className="modalHeader">
					{handleHeaderByType(props.nodeToEdit.type)}
					<div
						className="modalHeader-close"
						onClick={() => {
							props.saveNode(props.nodeToEdit);
							props.handleModalEdit();
						}}
					>
						<MdClose size={22} />
					</div>
				</div>
				<div className="modalContent">
					{props.nodeToEdit.type == "message" && (
						<div className="node-question">
							<div>
								<label htmlFor="">Tipo de mensagem</label>
								<select
									className="inputText"
									value={msgType}
									onChange={(e) => setMsgType(e.target.value)}
								>
									<option value="text">Texto</option>
									<option value="media">Mídia (arquivo)</option>
									<option value="media-url">Mídia (URL)</option>
								</select>
							</div>
							{msgType === "media" && (
								<div>
									<FileUploader
										file={file}
										setFile={setFile}
										msgMedia={msgMedia}
										setMsgMedia={setMediaURL}
									/>
								</div>
							)}
							<div
								ref={messageMidiaUrl}
								contentEditable="true"
								className="inputText"
								onPaste={handlePaste}
								style={{ display: msgType === "media-url" ? "block" : "none" }}
							></div>
							<div>
								<label>Escreva uma mensagem:</label>
								<div
									ref={msgMessage}
									contentEditable="true"
									className="inputTextArea"
									onPaste={handlePaste}
								></div>
								<AddVariablesInText
									variables={props.variables}
								></AddVariablesInText>
							</div>
						</div>
					)}
					{props.nodeToEdit.type == "wppFlows" && (
						<div className="node-question">
							<div>
								<label className="input-group-help">
									ID do Flow na Meta:
									<HelpMessage
										message={
											<>
												<a
													href="https://business.facebook.com/latest/whatsapp_manager/flows"
													target="_blank"
													rel="noopener noreferrer"
												>
													Acesse aqui
												</a>{" "}
												para visualizar os flows da sua empresa
											</>
										}
									/>
								</label>
								<input
									type="text"
									className="inputText"
									value={wppFlows?.id}
									onChange={(e) =>
										setWppFlows({ ...wppFlows, id: e.target.value.trim() })
									}
								/>
							</div>
							<div>
								<label>Webhook Alternativo:</label>
								<input
									type="text"
									className="inputText"
									value={wppFlows?.webhookAlternative}
									onChange={(e) =>
										setWppFlows({
											...wppFlows,
											webhookAlternative: e.target.value.trim(),
										})
									}
								/>
							</div>
							<div className="input-group-checkbox">
								<input
									type="checkbox"
									name="wpp-flows-required"
									id="wpp-flows-required"
									checked={!!wppFlows?.required}
									onChange={(e) =>
										setWppFlows({ ...wppFlows, required: e.target.checked })
									}
								/>
								<label htmlFor="wpp-flows-required">
									Envio do flow obrigatório
								</label>
							</div>
							{wppFlows?.required ? (
								<div>
									<label>Mensagem de obrigatoriedade:</label>
									<input
										type="text"
										className="inputText"
										placeholder="Ex: Para continuar, preencha o formulário."
										value={wppFlows?.requiredMessage || ""}
										onChange={(e) =>
											setWppFlows({
												...wppFlows,
												requiredMessage: e.target.value,
											})
										}
									/>
									<span className="spamSmall">
										*Enviada sempre que o contato responder algo diferente do
										flow
									</span>
								</div>
							) : (
								<div>
									<label>Salvar resposta em variável:</label>
									<select
										className="inputText"
										value={wppFlows?.saveVar || ""}
										onChange={(e) =>
											setWppFlows({ ...wppFlows, saveVar: e.target.value })
										}
									>
										<option value=""></option>
										{props.variables.map((varx) => (
											<option key={varx.name} value={varx.name}>
												{varx.name}{" "}
												{varx.propertyAssociate
													? `(${handlePropertyVar(varx, props.contactFields)})`
													: ""}
											</option>
										))}
									</select>
								</div>
							)}
						</div>
					)}

					{props.nodeToEdit.type == "gush" && (
						<div className="node-question">
							<div>
								<label>Tipo de transferência:</label>
								<select
									className="inputText"
									value={gushChoose}
									onChange={(e) => {
										setgushChoose(e.target.value);
										if (!gushChoose) {
											setgushSector(props.sectors[0]);
										}
										if (!gushOperators?.[0] && gushChoose !== "internal_id") {
											setgushOperators([props?.operators?.[0]?._id]);
										}
										if (gushChoose === "internal_id") {
											setgushOperators([]);
										}
									}}
								>
									<option value="sector">Por setor</option>
									<option value="operator">Por operador</option>
									<option value="internal_id">Inserir ID do atendente</option>
									<option value="number_owner">
										Proprietário do número de WhatsApp
									</option>
								</select>
							</div>
							{gushChoose === "sector" ? (
								<div>
									<label>Selecione um setor para transferir:</label>
									<select
										className="inputText"
										value={gushSector}
										onChange={(e) => setgushSector(e.target.value)}
									>
										{props.sectors.map((sec) => (
											<option value={sec}>{sec}</option>
										))}
									</select>
								</div>
							) : gushChoose === "operator" ? (
								<div>
									<label>Selecione um operator para transferir:</label>
									<select
										className="inputText"
										value={gushOperators?.[0]}
										onChange={(e) => setgushOperators([e.target.value])}
									>
										{props?.operators?.map((sec) => (
											<option value={sec._id}>
												{sec.name} ({sec.sector?.name})
											</option>
										))}
									</select>
								</div>
							) : gushChoose === "number_owner" ? (
								<>
									<div>
										<label htmlFor="transfer-type">
											Em caso de falha, distribuir para o setor:
										</label>
										<select
											className="inputText"
											value={gushSector}
											onChange={(e) => setgushSector(e.target.value)}
										>
											{props.sectors.map((sec) => (
												<option value={sec}>{sec}</option>
											))}
										</select>
									</div>
								</>
							) : (
								<>
									<div>
										<label>Insira o ID do atendente:</label>
										<div
											contentEditable="true"
											onPaste={handlePaste}
											className="inputText"
											ref={gushInternalIdRef}
										></div>
										<AddVariablesInText
											variables={props.variables}
										></AddVariablesInText>
									</div>
									<hr className="divisor-section" />
									<div>
										<label htmlFor="transfer-type">
											Em caso de falha, distribuir para o setor:
										</label>
										<select
											className="inputText"
											value={gushSector}
											onChange={(e) => setgushSector(e.target.value)}
										>
											{props.sectors.map((sec) => (
												<option value={sec}>{sec}</option>
											))}
										</select>
									</div>
								</>
							)}
							{(gushChoose === "sector" ||
								gushChoose === "internal_id" ||
								gushChoose === "number_owner") && (
								<>
									<hr className="divisor-section" />
									<h4 className="header-sub-section">
										Regra de distribuição de conversas
									</h4>
									<div>
										<label htmlFor="transfer-type">Regra de distribuição</label>
										<select
											name="transfer-type"
											id="transfer-type"
											className="inputText"
											value={gushType}
											onChange={(e) => setGushType(e.target.value)}
										>
											<option value="default">Padrão da conta</option>
											<option value="manual">Atribuição manual</option>
											<option value="operator">Proprietário</option>
											<option value="qttAttendance">
												Quantidade de atendimentos
											</option>
											<option value="random">Revezamento</option>
										</select>
									</div>
									{gushType === "operator" && (
										<div className="input-group-checkbox">
											<input
												type="checkbox"
												name="gush-only-owner"
												id="gush-only-owner"
												checked={onlyOwnerGush}
												onChange={(e) => setOnlyOwnerGush(e.target.checked)}
											/>
											<label htmlFor="gush-only-owner">
												Caso o proprietário esteja offline, distribuir para
												outro atendente online
											</label>
										</div>
									)}
								</>
							)}
						</div>
					)}

					{props.nodeToEdit.type == "createtask" && (
						<CreateTask
							setObjectData={setObjectData}
							objectData={objectData}
							owners={props.owners}
							variables={props.variables}
						/>
					)}

					{props.nodeToEdit.type == "createdeal" && (
						<CreateDeal
							objectData={objectData}
							owners={props.owners}
							customDealFields={props.customDealFields}
							pipelines={props.pipelines}
							variables={props.variables}
						/>
					)}

					{props.nodeToEdit.type == "createticket" && (
						<CreateTicket
							objectData={objectData}
							owners={props.owners}
							customTicketFields={props.customTicketFields}
							pipelines={props.ticketPipelines}
							variables={props.variables}
						/>
					)}

					{props.nodeToEdit.type == "sleep" && (
						<div className="node-question">
							<div>
								<label>Tempo de delay (segundos):</label>
								<input
									type="number"
									min={0}
									className="inputText"
									value={sleepSeconds}
									onChange={(e) => setSleepSeconds(e.target.value)}
								/>
							</div>
						</div>
					)}

					{props.nodeToEdit.type == "setvar" && (
						<div className="node-question">
							<div>
								<label>Variável:</label>
								<select
									className="inputText"
									value={varToSet}
									onChange={(e) => setvarToSet(e.target.value)}
								>
									{props.variables.map((varx) => (
										<option key={varx.name} value={varx.name}>
											{varx.name}{" "}
											{varx.propertyAssociate
												? ` (${handlePropertyVar(varx, props.contactFields)})`
												: ""}
										</option>
									))}
								</select>
							</div>
							<div>
								<label>Novo valor:</label>
								<input
									type="text"
									className="inputText"
									value={valueToset}
									onChange={(e) => setvalueToset(e.target.value)}
								/>
							</div>
						</div>
					)}

					{props.nodeToEdit.type == "settag" && (
						<div className="node-question">
							<div>
								<label>Tags</label>
								<select
									className="inputText"
									value={tagsToSet}
									onChange={(e) => {
										setTagsToSet(
											[...e.target.selectedOptions].map((op) => op.value)
										);
									}}
									multiple
								>
									{props.tags.map((tag) => (
										<option value={tag._id}>
											{tag.name}
											{tag?.sector?.name
												? ` - Setor: ${tag?.sector?.name}`
												: ""}
										</option>
									))}
								</select>
							</div>
						</div>
					)}

					{props.nodeToEdit.type == "createnote" && (
						<div className="node-question">
							<div>
								<label>Anotação:</label>
								<textarea
									type="text"
									className="inputTextArea"
									value={comment}
									onInput={(e) => {
										setComment(e.target.value);
									}}
								></textarea>
							</div>
						</div>
					)}

					{props.nodeToEdit.type == "webhook" && (
						<div className="node-question">
							<div>
								<label>Url:</label>
								<div
									ref={webhookUrl}
									contentEditable="true"
									className="inputText"
									onPaste={handlePaste}
								></div>
							</div>
							<div>
								<label>Método</label>
								<select
									className="inputText"
									value={webhookMethod}
									onChange={(e) => {
										setwebhookMethod(e.target.value);
									}}
								>
									{webhookMethods.map((who) => (
										<option key={who.value} value={who.value}>
											{who.label}
										</option>
									))}
								</select>
							</div>
							<div className="node-question-groupped">
								<label>
									Cabeçalho da requisição:
									<small
										style={{
											float: "right",
											fontWeight: "bold",
											cursor: "pointer",
										}}
										onClick={addWebhookHeader}
									>
										Adicionar
									</small>
								</label>
								{webhookHeaders.map((header) => (
									<div className="input-group-flex">
										<div>
											<label htmlFor="">Chave</label>
											<input
												type="text"
												value={header.label}
												className="inputText"
												onChange={handleWebhookHeaders(header, "label")}
											/>
										</div>
										<div>
											<label htmlFor="">Valor</label>
											<div
												contentEditable="true"
												onPaste={handlePaste}
												className="inputTextArea"
												style={{
													lineHeight: "24px",
												}}
												data-header-id={header.id}
											>
												{header?.value}
											</div>
										</div>
										<button
											title="Apagar Header"
											onClick={() => handleRemoveHeader(header)}
										>
											<FaTrash size={13} />
										</button>
									</div>
								))}

								<span className="spamSmall warning">{messageWarning}</span>
							</div>
							<div>
								<label>
									Corpo da requisição:
									<small
										style={{
											float: "right",
											fontWeight: "bold",
											cursor: "pointer",
										}}
										onClick={formatJson}
									>
										Formatar JSON
									</small>
								</label>
								<div
									ref={webhookBody}
									contentEditable="true"
									onPaste={handlePaste}
									className="inputTextArea"
									style={{
										lineHeight: "24px",
									}}
								></div>
								<span className="spamSmall warning">{messageWarning}</span>
							</div>
							<div>
								<AddVariablesInText
									variables={props.variables}
									showCreateVarButton={true}
									handleModalVariable={props.handleModalVariable}
								></AddVariablesInText>
							</div>
							<div>
								<h4>Salvar respostas como variáveis</h4>
							</div>
							<div>
								<label htmlFor="">
									Variável{" "}
									<BsFillArrowLeftSquareFill></BsFillArrowLeftSquareFill> Campo
									JSON
								</label>
								{inputsSaveResp.length === 0 ? (
									<div
										style={{
											padding: "20px",
											textAlign: "center",
											color: "#999",
											fontSize: "14px",
											fontStyle: "italic",
										}}
									>
										Nenhuma atribuição de variável definida
									</div>
								) : (
									inputsSaveResp.map((i) => (
										<div className="webhook-vars" key={i}>
											<select
												className="inputText"
												id={`var-${i}`}
												value={webhookVars ? webhookVars[i] : ""}
												onChange={(e) => onchangeVarsResps(e.target)}
											>
												<option value=""></option>
												{props.variables.map((varx) => (
													<option key={varx.name} value={varx.name}>
														{varx.name}
													</option>
												))}
											</select>

											<BsFillArrowLeftSquareFill></BsFillArrowLeftSquareFill>
											<input
												type="text"
												id={`resp-${i}`}
												className="inputText"
												value={webhookResps ? webhookResps[i] : ""}
												onChange={(e) => onchangeVarsResps(e.target)}
											/>

											<FaTrash
												onClick={() => removeInputResp(i)}
												className="remove-var-webhook"
											/>
										</div>
									))
								)}
							</div>
							<div style={{ display: "flex", justifyContent: "flex-end" }}>
								<button
									onClick={addInputResp}
									className="add-button-simple"
									title="Adicionar"
								>
									<FaPlus size={14} />
								</button>
							</div>
						</div>
					)}

					{props.nodeToEdit.type == "aiagent" && (
						<div className="node-question">
							<div>
								<label>Selecione um agente</label>
								<select
									className="inputText"
									value={aiAgent}
									onChange={(e) => setAiAgent(e.target.value)}
								>
									<option value=""></option>
									{(props.agents || []).map((agent) => (
										<option key={agent.id} value={agent.id}>
											{agent.name}
										</option>
									))}
								</select>
							</div>

							{(() => {
								const selectedAgent = (props.agents || []).find(
									(a) => a?.id === aiAgent || a?._id === aiAgent
								);
								if (!selectedAgent) return null;

								const {
									objective,
									agent_role,
									speaking_style,
									status,
									variables = [],
									tools = [],
									datasets = [],
									custom_rules = [],
									prompt_stages = [],
								} = selectedAgent;
								const isActive = status === "active";
								const role = agent_role?.prompt_instructions;
								const style = speaking_style?.prompt_instructions;
								const stages = [...prompt_stages].sort(
									(a, b) => (a.order || 0) - (b.order || 0)
								);

								return (
									<div className="ai-overview">
										<div className="ai-overview-head">
											<h4>Visão geral do agente</h4>
											<button
												type="button"
												className="ai-overview-open"
												onClick={handleOpenAiAgents}
												title="Abrir a listagem de agentes em nova guia"
											>
												Abrir agente
												<FaExternalLinkAlt size={10} />
											</button>
										</div>

										<div className="ai-overview-badges">
											{status && (
												<span
													className={`ai-overview-status ${isActive ? "on" : "off"}`}
												>
													{isActive ? "Ativo" : "Inativo"}
												</span>
											)}
											{role && <span className="ai-overview-chip">{role}</span>}
											{style && (
												<span className="ai-overview-chip">{style}</span>
											)}
										</div>

										{objective && (
											<div className="ai-overview-block">
												<label>Objetivo</label>
												<p>{objective}</p>
											</div>
										)}

										{variables.length > 0 && (
											<div className="ai-overview-block">
												<label>Variáveis de entrada ({variables.length})</label>
												<ul className="ai-overview-list">
													{variables.map((v) => (
														<li key={v._id || v.label}>
															<div className="ai-overview-item-top">
																<strong>{v.label}</strong>
																{v.required && (
																	<span className="ai-overview-req">
																		obrigatória
																	</span>
																)}
															</div>
															{v.instructions && (
																<span className="ai-overview-desc">
																	{v.instructions}
																</span>
															)}
														</li>
													))}
												</ul>
											</div>
										)}

										{tools.length > 0 && (
											<div className="ai-overview-block">
												<label>Ferramentas ({tools.length})</label>
												<ul className="ai-overview-list">
													{tools.map((t) => (
														<li key={t._id || t.identifier || t.name}>
															<div className="ai-overview-item-top">
																<strong>{t.name}</strong>
																{Array.isArray(t.data) && t.data.length > 0 && (
																	<span className="ai-overview-fields">
																		{t.data.length} campo
																		{t.data.length > 1 ? "s" : ""}
																	</span>
																)}
															</div>
															{t.instructions && (
																<span className="ai-overview-desc">
																	{t.instructions}
																</span>
															)}
														</li>
													))}
												</ul>
											</div>
										)}

										{stages.length > 0 && (
											<div className="ai-overview-block">
												<label>Etapas ({stages.length})</label>
												<ol className="ai-overview-stages">
													{stages.map((s) => (
														<li key={s._id || s.order}>{s.prompt}</li>
													))}
												</ol>
											</div>
										)}

										{datasets.length > 0 && (
											<div className="ai-overview-block">
												<label>Bases de conhecimento ({datasets.length})</label>
												<div className="ai-overview-badges">
													{datasets.map((d) => (
														<span
															key={d.datasetId?._id || d.datasetId?.name}
															className="ai-overview-chip"
														>
															{d.datasetId?.name || "—"}
														</span>
													))}
												</div>
											</div>
										)}

										{custom_rules.length > 0 && (
											<div className="ai-overview-block">
												<label>Regras ({custom_rules.length})</label>
												<ul className="ai-overview-list ai-overview-rules">
													{custom_rules.map((r, i) => (
														<li key={r?._id || i}>
															{typeof r === "string" ? r : r?.instructions}
														</li>
													))}
												</ul>
											</div>
										)}
									</div>
								);
							})()}

							<div>
								<h4>Contexto de entrada</h4>
							</div>
							<div>
								<label htmlFor="">
									Campo <BsFillArrowLeftSquareFill></BsFillArrowLeftSquareFill>{" "}
									Valor
								</label>
								{aiInputVariables.length === 0 ? (
									<div
										style={{
											padding: "20px",
											textAlign: "center",
											color: "#999",
											fontSize: "14px",
											fontStyle: "italic",
										}}
									>
										Nenhuma entrada definida
									</div>
								) : (
									aiInputVariables.map((inputVar) => (
										<div className="webhook-vars" key={inputVar.id}>
											<div
												ref={(el) => {
													if (el)
														aiInputVarRefs.current[`${inputVar.id}-label`] = el;
												}}
												contentEditable="true"
												className="inputText"
												onPaste={handlePaste}
												onBlur={(e) =>
													updateAiInputVariable(
														inputVar.id,
														"label",
														e.target.innerHTML
													)
												}
											></div>

											<BsFillArrowLeftSquareFill></BsFillArrowLeftSquareFill>

											<div
												ref={(el) => {
													if (el)
														aiInputVarRefs.current[`${inputVar.id}-value`] = el;
												}}
												contentEditable="true"
												className="inputText"
												onPaste={handlePaste}
												onBlur={(e) =>
													updateAiInputVariable(
														inputVar.id,
														"value",
														e.target.innerHTML
													)
												}
											></div>

											<FaTrash
												onClick={() => removeAiInputVariable(inputVar.id)}
												className="remove-var-webhook"
											/>
										</div>
									))
								)}
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<button
									onClick={addAiInputVariable}
									className="add-button-simple"
									title="Adicionar"
								>
									<FaPlus size={14} />
								</button>
							</div>
							<div>
								<AddVariablesInText
									variables={props.variables}
								></AddVariablesInText>
							</div>

							<div style={{ marginTop: "20px" }}>
								<h4>Saídas</h4>
								<small style={{ color: "#666", fontSize: "12px" }}>
									As saídas são definidas na configuração do agente
								</small>
							</div>
							<div>
								{(() => {
									const selectedAgent = (props.agents || []).find(
										(a) => a?.id === aiAgent || a?._id === aiAgent
									);
									const outputs = selectedAgent?.outputs || [];

									if (outputs.length === 0) {
										return (
											<div
												style={{
													padding: "20px",
													textAlign: "center",
													color: "#999",
													fontSize: "14px",
													fontStyle: "italic",
												}}
											>
												Nenhuma saída definida
											</div>
										);
									}

									return outputs.map((output) => (
										<div
											key={output._id || output.name}
											style={{
												backgroundColor: "#fff",
												padding: "15px",
												marginTop: "10px",
												borderRadius: "4px",
												boxShadow: "0 1px 5px -1px #0000005c",
												fontSize: "14px",
											}}
										>
											{output.name}
										</div>
									));
								})()}
							</div>

							{/* Mapeamento de Saída */}
							<div style={{ marginTop: "20px" }}>
								<h4>Mapeamento de Saída</h4>
								<small style={{ color: "#666", fontSize: "12px" }}>
									Mapeie as variáveis do agente para as variáveis do bot
								</small>
							</div>
							<div>
								<label htmlFor="">
									Variável do Bot{" "}
									<BsFillArrowLeftSquareFill></BsFillArrowLeftSquareFill>{" "}
									Variável do Agente
								</label>
								{aiOutputMapping.length === 0 ? (
									<div
										style={{
											padding: "20px",
											textAlign: "center",
											color: "#999",
											fontSize: "14px",
											fontStyle: "italic",
										}}
									>
										Nenhum mapeamento definido
									</div>
								) : (
									aiOutputMapping.map((mapping) => {
										const selectedAgent = (props.agents || []).find(
											(a) => a?.id === aiAgent || a?._id === aiAgent
										);
										const agentVariables = selectedAgent?.variables || [];

										return (
											<div className="webhook-vars" key={mapping.id}>
												<select
													className="inputText"
													value={mapping.botVariable}
													onChange={(e) =>
														updateAiOutputMapping(
															mapping.id,
															"botVariable",
															e.target.value
														)
													}
												>
													<option value="">Selecione...</option>
													{props.variables.map((varx) => (
														<option key={varx._id} value={varx._id}>
															{varx.name}
														</option>
													))}
												</select>

												<BsFillArrowLeftSquareFill></BsFillArrowLeftSquareFill>

												<select
													className="inputText"
													value={mapping.agentVariable}
													onChange={(e) =>
														updateAiOutputMapping(
															mapping.id,
															"agentVariable",
															e.target.value
														)
													}
												>
													<option value="">Selecione...</option>
													{agentVariables.map((agentVar) => (
														<option key={agentVar._id} value={agentVar._id}>
															{agentVar.label}
														</option>
													))}
												</select>

												<FaTrash
													onClick={() => removeAiOutputMapping(mapping.id)}
													className="remove-var-webhook"
												/>
											</div>
										);
									})
								)}
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<button
									onClick={addAiOutputMapping}
									className="add-button-simple"
									title="Adicionar"
								>
									<FaPlus size={14} />
								</button>
							</div>
						</div>
					)}

					{props.nodeToEdit.type == "question" && (
						<div className="node-question">
							<div>
								<label>Pergunta:</label>
								<div
									ref={question}
									contentEditable="true"
									className="inputTextArea"
									onPaste={handlePaste}
								></div>
								<AddVariablesInText
									variables={props.variables}
									questionEl={question}
									showCreateVarButton={true}
									handleModalVariable={props.handleModalVariable}
								></AddVariablesInText>
							</div>

							<div>
								<label>Tipo de resposta:</label>
								<select
									className="inputText"
									value={questionTypeResponse}
									onChange={(e) => {
										setQuestionTypeResponse(e.target.value);
										setQuestionResponseActions({});
										setDuplicateError("");
									}}
								>
									<option value="simple">Simples</option>
									<option value="buttons">Botões</option>
									<option value="list">Lista</option>
								</select>
							</div>

							<div
								className="questionList"
								style={{
									display: questionTypeResponse == "buttons" ? "block" : "none",
								}}
							>
								{Object.keys(questionResponseActions).map((x) => (
									<div>
										<input
											type="text"
											id={`question-btn-${x}`}
											className="inputText"
											value={questionResponseActions[x]}
											onChange={(e) => onchangeRespButtons(e.target)}
											onBlur={(e) => onBlurRespButtons(e.target)}
										/>
										<button
											onClick={() => {
												removeInputButton(x);
											}}
										>
											<FaTrash />
										</button>
									</div>
								))}
								{duplicateError && questionTypeResponse === "buttons" && (
									<div
										style={{
											color: "#e74c3c",
											fontSize: "13px",
											marginTop: "8px",
											fontWeight: "500",
										}}
									>
										{duplicateError}
									</div>
								)}

								<div className="add-new-button" onClick={addInputButton}>
									<div>
										<FaPlus />
									</div>
									<span>Adicionar novo botão</span>
								</div>
							</div>

							<div
								className="questionList"
								style={{
									display: questionTypeResponse == "list" ? "block" : "none",
								}}
							>
								<div className="input-group list-title">
									<label htmlFor="">Texto para seleção da lista</label>
									<input
										type="text"
										className="inputText"
										placeholder="Ex: Clique para selecionar uma opção"
										value={questionResponseActions.buttonTitle}
										onChange={(e) => {
											const value = e.target.value.slice(0, 20);
											onchangeButtonSectionTitle({ ...e.target, value });
										}}
									/>
								</div>
								<hr />
								{questionResponseActions.sections &&
									Object.keys(questionResponseActions.sections).map((x, i) => (
										<div>
											<div className="item-section">
												<div className="input-group">
													<label>Sessão:</label>
													<div className="full-input">
														<input
															type="text"
															id={`section-${x}`}
															className="inputText"
															value={questionResponseActions.sections[x].title}
															onChange={(e) => onchangeSectionTitle(e.target)}
															onBlur={onBlurSectionTitle}
															placeholder="Ex: Financeiro:"
														/>
														<button>
															<FaTrash
																onClick={() => {
																	removeSession(x);
																}}
															/>
														</button>
													</div>
												</div>

												<div className="question-sections">
													{Object.keys(
														questionResponseActions.sections[x].items || {}
													).map((it) => (
														<div>
															<div className="input-group">
																<label htmlFor="">Nome do item:</label>
																<div className="full-input">
																	<input
																		type="text"
																		id={
																			questionResponseActions.sections[x].items[
																				it
																			].id
																		}
																		className="inputText"
																		style={{ width: "150px" }}
																		value={
																			questionResponseActions.sections[x].items[
																				it
																			].title
																		}
																		onChange={(e) =>
																			onchangeButtonTitle(e.target)
																		}
																		onBlur={(e) => onBlurButtonTitle(e.target)}
																		placeholder="Ex: Conta"
																	/>
																	<button>
																		<FaTrash
																			onClick={() => {
																				removeSessionItem(x, it);
																			}}
																		/>
																	</button>
																</div>
															</div>
															<div className="input-group">
																<label htmlFor="">Descrição do item:</label>
																<input
																	type="text"
																	id={
																		questionResponseActions.sections[x].items[
																			it
																		].id
																	}
																	className="inputText"
																	style={{
																		height: "10px",
																		fontSize: "12px",
																	}}
																	value={
																		questionResponseActions.sections[x].items[
																			it
																		].description
																	}
																	onChange={(e) =>
																		onchangeButtonDescription(e.target)
																	}
																	placeholder="Ex: Desejo falar sobre minha conta"
																/>
															</div>
															<hr></hr>
														</div>
													))}
												</div>
												<div
													className="section-add-item add-new-button"
													onClick={() => {
														addItemSectionQuestion(x);
													}}
												>
													<div>
														<FaPlus />
													</div>
													<span>Adicionar item</span>
												</div>
											</div>
										</div>
									))}
								{duplicateError && questionTypeResponse === "list" && (
									<div
										style={{
											color: "#e74c3c",
											fontSize: "13px",
											marginTop: "8px",
											marginBottom: "8px",
											fontWeight: "500",
										}}
									>
										{duplicateError}
									</div>
								)}
								<div
									className="add-new-button"
									onClick={addSectionListQuestion}
								>
									<div>
										<FaPlus />
									</div>
									<span>Adicionar sessão</span>
								</div>
							</div>

							<div>
								<label>Salve as respostas na variável:</label>
								<select
									className="inputText"
									value={questionVar}
									onChange={(e) => setquestionVar(e.target.value)}
								>
									<option value=""></option>
									{props.variables.map((varx) => (
										<option key={varx.name} value={varx.name}>
											{varx.name}{" "}
											{varx.propertyAssociate
												? `(${handlePropertyVar(varx, props.contactFields)})`
												: ""}
										</option>
									))}
								</select>
								<span className="spamSmall">
									*Se a variavel for igual a "email", a validação acontecerá
									automaticamente
								</span>
							</div>

							{questionVar === "email" && (
								<div>
									<label>Mensagem de erro:</label>
									<input
										type="text"
										className="inputText"
										placeholder="Ex: E-mail incorreto, tente novamente."
										onChange={(e) => setQuestionErrorMessage(e.target.value)}
										value={questionErrorMessage}
									/>
								</div>
							)}
						</div>
					)}

					{props.nodeToEdit.type == "conditional" && (
						<div className="node-question">
							<div>
								<label>Selecione uma opção para comparar</label>
								<select
									className="inputText"
									value={condVar}
									onChange={(e) => setcondVar(e.target.value)}
								>
									{handleCustomOptions()}
									{props.variables.map((varx) => (
										<option key={varx.name} value={varx.name}>
											{varx.name}{" "}
											{varx.propertyAssociate
												? `(${handlePropertyVar(varx, props.contactFields)})`
												: ""}
										</option>
									))}
								</select>
							</div>

							<div className={!condTypeVisible ? "hidden" : ""}>
								<label>Comparação</label>
								<select
									className="inputText"
									value={condType}
									onChange={(e) => setcondType(e.target.value)}
								>
									{Object.keys(nameConditions).map((it) => (
										<option value={it}>{nameConditions[it]}</option>
									))}
								</select>
							</div>

							<div className={!condValueVisible ? "hidden" : ""}>
								<label>Valor</label>
								<div
									ref={condValue}
									contentEditable="true"
									className="inputText"
									onPaste={handlePaste}
								></div>
								<AddVariablesInText
									variables={props.variables}
								></AddVariablesInText>
							</div>
						</div>
					)}

					{props.nodeToEdit.type == "jump" && (
						<div className="node-question">
							<div>
								<label>Selecione uma variável para comparar</label>
								<select
									className="inputText"
									value={jumpVar}
									onChange={(e) => setjumpVar(e.target.value)}
								>
									{props.variables.map((varx) => (
										<option key={varx.name} value={varx.name}>
											{varx.name}
										</option>
									))}
								</select>
							</div>
							<div className="questionList">
								{Object.keys(jumps).map((x, i) => (
									<div className="input-full">
										<input
											title={jumps[x]}
											type="text"
											id={`out-${x}`}
											className="inputText"
											style={{ width: "100px" }}
											value={jumps[x]}
											onChange={(e) => onchangeJump(e.target)}
										/>
										<button onClick={() => removeJump(x)}>
											<FaTrash />
										</button>
									</div>
								))}

								<div className="add-new-button" onClick={addInputJump}>
									<div>
										<FaPlus />
									</div>
									<span>Adicionar novo jump</span>
								</div>
							</div>
						</div>
					)}

					{props.nodeToEdit.type == "outputbalancer" && (
						<div className="node-question">
							<div>
								<label>Saídas do balanceador</label>
								<small
									style={{ color: "#888", display: "block", marginBottom: 8 }}
								>
									A soma das probabilidades deve ser exatamente 100%.
								</small>
							</div>
							<div className="questionList">
								{Object.keys(balancerOutputs).map((key) => (
									<div className="input-full" key={key}>
										<input
											type="text"
											placeholder="Nome da saída"
											className="inputText"
											style={{ width: "100px" }}
											value={balancerOutputs[key]?.name || ""}
											onChange={(e) =>
												onchangeBalancerName(key, e.target.value)
											}
										/>
										<input
											type="number"
											placeholder="0"
											className="inputText"
											style={{ width: "40px", textAlign: "center" }}
											min="0"
											max="100"
											value={balancerOutputs[key]?.percentage || ""}
											onChange={(e) =>
												onchangeBalancerPercentage(key, e.target.value)
											}
										/>
										<span
											style={{
												fontSize: 13,
												color: "#666",
												fontWeight: 500,
												marginRight: 30,
											}}
										>
											%
										</span>
										<button
											onClick={() => removeBalancerOutput(key)}
											style={{ marginLeft: 8 }}
										>
											<FaTrash />
										</button>
									</div>
								))}

								<div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
									Total:{" "}
									<b
										style={{
											color:
												Object.values(balancerOutputs).reduce(
													(sum, o) => sum + (o?.percentage || 0),
													0
												) === 100
													? "#3ccfa0"
													: "#e74c3c",
										}}
									>
										{Object.values(balancerOutputs).reduce(
											(sum, o) => sum + (o?.percentage || 0),
											0
										)}
										%
									</b>
								</div>

								<div className="add-new-button" onClick={addBalancerOutput}>
									<div>
										<FaPlus />
									</div>
									<span>Adicionar nova saída</span>
								</div>
							</div>
						</div>
					)}
				</div>

				<div className="modalBottom">
					<button
						onClick={() => {
							props.saveNode(props.nodeToEdit);
							props.handleModalEdit();
						}}
						className="btnModal btnCancel"
					>
						Cancelar
					</button>
					<button
						onClick={saveNode}
						className="btnModal btnSaveModal"
						disabled={!!duplicateError}
						style={
							duplicateError ? { opacity: 0.5, cursor: "not-allowed" } : {}
						}
						title={duplicateError || "Salvar"}
					>
						Salvar
					</button>
				</div>
			</div>
		</>
	);
}

export default Modal;
